import React, { useEffect } from 'react';
import { initMetaPixel } from './utils/metaPixel';
import { Hero } from './components/Hero';
import { SocialProof } from './components/SocialProof';
import { SocialProofPopup } from './components/SocialProofPopup';
import { Testimonials } from './components/Testimonials';
import { PainPoints } from './components/PainPoints';
import { Tomos } from './components/Tomos';
import { Bonuses } from './components/Bonuses';
import { CountdownTimer } from './components/CountdownTimer';
import { PricingCards } from './components/PricingCards';
import { ComparisonTable } from './components/ComparisonTable';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { CostOfInaction } from './components/CostOfInaction';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
const testimonialsSet1 = [{
  name: 'Marcela G.',
  location: 'Córdoba',
  quote: 'Llevaba años sintiéndome estancada sin entender por qué. En la primera semana del Tomo 1 identifiqué 4 creencias que me frenaban desde la infancia. Cambié cómo cobro, cómo decido y cómo me relaciono. No es exageración.',
  rating: 5
}, {
  name: 'Laura P.',
  location: 'Buenos Aires',
  quote: 'El Tomo 2 de Relaciones Magnéticas me cambió los vínculos para siempre. Aprendí a leer a las personas, a comunicarme con poder y a dejar de tolerar lo que me drenaba. Hoy tengo relaciones que me suman de verdad.',
  rating: 5
}, {
  name: 'Romina M.',
  location: 'Rosario',
  quote: 'Con el país como está, pensé que era imposible avanzar. El Sistema Soberano me demostró que el único contexto que realmente me limitaba era el que yo tenía adentro. Ahora tengo mi propio emprendimiento y clientes reales.',
  rating: 5
}];
const testimonialsSet2 = [{
  name: 'Cecilia R.',
  location: 'Mendoza',
  quote: 'El Tomo 1 me hizo ver que mi relación con el dinero era la de mis abuelos, no la mía. En 30 días cambié cómo cobro, cómo ahorro y cómo pienso cada vez que veo el precio del dólar. El contexto no cambió. Yo sí.',
  rating: 5
}, {
  name: 'Sofía C.',
  location: 'La Plata',
  quote: 'El Bono de Anclajes me salvó la vida laboral. Trabajo en ventas y antes de cada reunión importante me bloqueaba. Ahora disparo el anclaje de seguridad y entro en otro estado completamente. Cerré 3 ventas grandes en 2 semanas.',
  rating: 5
}, {
  name: 'Paula A.',
  location: 'Neuquén',
  quote: 'El Tomo 6 de Maestría Emocional fue lo que más necesitaba y lo que menos sabía que necesitaba. Entendí por qué reacciono como reacciono. Ahora elijo cómo responder. Eso cambió todo en mi casa y en mi trabajo.',
  rating: 5
}, {
  name: 'Julia M.',
  location: 'Tucumán',
  quote: 'Compré el pack completo con el Protocolo de Emergencia. El Diccionario de Respuestas Poderosas solo ya vale todo. Antes me quedaba sin palabras cuando alguien me atacaba. Ahora tengo la respuesta exacta para cada situación.',
  rating: 5
}, {
  name: 'Martín F.',
  location: 'CABA',
  quote: 'Soy psicólogo y compré el Sistema Soberano con escepticismo. Me sorprendió la profundidad y la aplicación práctica. El Tomo 4 de Salud Neuro-Inmune tiene protocolos que uso con mis propios pacientes. Material serio y bien fundamentado.',
  rating: 5
}, {
  name: 'Valeria L.',
  location: 'San Juan',
  quote: 'El Planner de Abundancia de 30 Días fue lo que me faltaba. Tenía toda la información del mundo pero no la aplicaba. El planner me obligó a hacer una cosa por día. En 30 días avancé más que en los 2 años anteriores.',
  rating: 5
}];
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="min-h-screen bg-dark text-white font-body selection:bg-gold/30 selection:text-white" data-id="element-0">
      <SocialProofPopup data-id="element-1" />
      <Hero data-id="element-2" />
      <SocialProof data-id="element-3" />
      <Testimonials testimonials={testimonialsSet1} data-id="element-4" />
      <PainPoints data-id="element-5" />
      <Tomos data-id="element-6" />
      <Bonuses data-id="element-7" />

      <section className="py-20 px-4" data-id="element-8">
        <CountdownTimer data-id="element-9" />
      </section>

      <PricingCards data-id="element-10" />
      <ComparisonTable data-id="element-11" />
      <Testimonials testimonials={testimonialsSet2} title="LO QUE DICEN QUIENES YA LO TIENEN" data-id="element-12" />
      <Guarantee data-id="element-13" />
      <FAQ data-id="element-14" />
      <CostOfInaction data-id="element-15" />
      <FinalCTA data-id="element-16" />
      <Footer data-id="element-17" />
    </div>;
}